import 'regenerator-runtime/runtime';
import { call, takeEvery } from 'redux-saga/effects';
import { AnyAction } from 'redux';
import {
  GlobalActions,
  GlobalEventDispatcher,
  GlobalPut,
  HTTP_METHOD,
} from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { PS20Logger } from '@ps20-frontend/logging';
import { Kooperation } from '@ps20/bff-models';

export const URL = '/privatschutz/api/kooperationen';

export enum KOOPERATIONEN_REQUESTED_EVENTS {
  KOOPERATIONEN_REQUESTED_SUCCESSFUL = 'KOOPERATIONEN_REQUESTED_SUCCESSFUL',
  KOOPERATIONEN_REQUESTED_FAILED = 'KOOPERATIONEN_REQUESTED_FAILED',
}

export function* watchKooperationenRequest() {
  yield takeEvery(
    GlobalActions.AUTHENTICATION_SUCCESSFUL,
    safeSaga(getKooperationenSaga, App.SHOP_TOOLBAR),
  );
  yield takeEvery(
    KOOPERATIONEN_REQUESTED_EVENTS.KOOPERATIONEN_REQUESTED_SUCCESSFUL,
    safeSaga(successCallback, App.SHOP_TOOLBAR),
  );
  yield takeEvery(
    KOOPERATIONEN_REQUESTED_EVENTS.KOOPERATIONEN_REQUESTED_FAILED,
    safeSaga(errorCallback, App.SHOP_TOOLBAR),
  );
}

export function* getKooperationenSaga() {
  const globalPut = GlobalPut.getInstance();
  yield call(
    globalPut.put.bind(globalPut),
    new GlobalActions().doRequest({
      appId: App.SHOP_TOOLBAR,
      method: HTTP_METHOD.GET,
      body: '',
      url: URL,
      successEvent: KOOPERATIONEN_REQUESTED_EVENTS.KOOPERATIONEN_REQUESTED_SUCCESSFUL,
      errorEvent: KOOPERATIONEN_REQUESTED_EVENTS.KOOPERATIONEN_REQUESTED_FAILED,
    }),
  );
}

export function successCallback(successAction: AnyAction) {
  const kooperationenResponse: Kooperation[] = successAction.payload;
  GlobalEventDispatcher.getInstance().dispatch(
    new GlobalActions().kooperationenListReceived(kooperationenResponse),
  );
}

export function errorCallback(errorAction: AnyAction) {
  PS20Logger.error(
    App.SHOP,
    'Loading kooperationen from bff failed.',
    errorAction.payload.toString(),
  );
}
